import { MUpdatePrice } from "../../../../../../server/routes/logUpdated/price/types";
import usePageLogUpdatedPriceContext from "./usePageLogUpdatedPriceContext";

const useLastIdByPage = () => {
  const {
    lastIdByPage,
    page: { value: page },
  } = usePageLogUpdatedPriceContext();

  return {
    lastIdInPrevPage: lastIdByPage.value[page - 2],
    lastId: lastIdByPage.value[page] ?? 0,
    updateLastPage: (page: number, items: MUpdatePrice[]) => {
      lastIdByPage.update({
        ...lastIdByPage.value,
        [page]: Math.min(...items.map(({ id }) => id)),
      });
    },
  };
};

export default useLastIdByPage;
